import React from "react";
import PDFPage from "pdfs/PDFPage";
import MonthlySeoSection from "./MonthlySeoSection";

export default function MonthlySeoReport(props) {
  const page = props.page;
  const seo_cc_data = props.seo_cc_data;
  const dashboard = props.dashboard;

  if (page) {
    if (page["metricNames"]) {
      let sectionNames = page["metricNames"].map((metric) => metric["section"]).filter((value, index, self) => self.indexOf(value) === index);
      let sections = [];
      // Create sections object and format how the dashboard generation loop expects
      sectionNames.forEach((section) => {
        sections.push({
          name: section,
          metrics_data: page["metricNames"]
            .filter((m) => m["section"] == section)
            .reduce((sum, item) => {
              sum[item["name"]] = "1";
              return sum;
            }, {}),
        });
      });

      return (
        <PDFPage pageNumber={props.pageNumber} hideLogo={props.white_label_service}>
          {sections.map((section, index) => {
            return (
              <div key={index}>
                <MonthlySeoSection section={section} cc_data={seo_cc_data} sectionIndex={index} dashboard={dashboard} {...props} />
              </div>
            );
          })}
        </PDFPage>
      );
    } else {
      return (
        <>
          <h4 className="text-danger">no metricsData in page</h4>
        </>
      );
    }
  } else {
    return (
      <></>
    )
  }
}
